export default {
  zoom: {
    label: 'Zoom options',
    keys: ['z'],
    default: false,
    desc: 'Shows zoom options on canvas'
  },
  zoomIn: {
    label: 'Zoom in',
    keys: ['super+='],
    default: true,
    desc: 'Zooms in on canvas'
  },
  zoomOut: {
    label: 'Zoom Out',
    keys: ['super+-'],
    default: true,
    desc: 'Zooms out on canvas'
  },
  zoomReset: {
    label: 'Zoom reset',
    keys: ['super+0'],
    default: true,
    desc: 'Zooms and resets canvas so everything is visible'
  },
  zoomToFit: {
    label: 'Zoom fill',
    keys: ['super+1'],
    default: true,
    desc: 'Zooms so canvas fills screen'
  },

  grid: {
    label: 'Show grid',
    keys: ['w'],
    default: false,
    desc: 'Show grid guide lines'
  }
};
